export const FAILED = 20010;
export const FAILED1 = 1001;
export const FAILED2 = 1002;